<template>

  <svg
    t="1631088842025"
    class="icon"
    viewBox="0 0 1024 1024"
    version="1.1"
    xmlns="http://www.w3.org/2000/svg"
    p-id="4505"
    width="64"
    height="64"
  ><path d="M128 896h816c8.837 0 16 7.163 16 16v32c0 8.837-7.163 16-16 16H80a15.95 15.95 0 0 1-11.314-4.686A15.95 15.95 0 0 1 64 944V80c0-8.837 7.163-16 16-16h32c8.837 0 16 7.163 16 16v816z m96-325h48c8.837 0 16 7.163 16 16v220c0 8.837-7.163 16-16 16h-48c-8.837 0-16-7.163-16-16V587c0-8.837 7.163-16 16-16z m360-112h48c8.837 0 16 7.163 16 16v332c0 8.837-7.163 16-16 16h-48c-8.837 0-16-7.163-16-16V475c0-8.837 7.163-16 16-16zM404 248h48c8.837 0 16 7.163 16 16v543c0 8.837-7.163 16-16 16h-48c-8.837 0-16-7.163-16-16V264c0-8.837 7.163-16 16-16z m360-99h48c8.837 0 16 7.163 16 16v642c0 8.837-7.163 16-16 16h-48c-8.837 0-16-7.163-16-16V165c0-8.837 7.163-16 16-16z" p-id="4506" /></svg>


</template>

<script lang="ts">
import type { DefineComponent } from 'vue'
export default {
  name: 'JtIconChartBar',
} as DefineComponent
</script>